import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import 'typeface-roboto'
import firebase from 'firebase';
import '@firebase/firestore'

window.firebase = firebase;

// Initialize Firebase
var config = {
  apiKey: "AIzaSyCvHOwoaVHAYKYP-5qV9oMGgy67CT13A04",
  authDomain: "darwin-journal-prod.firebaseapp.com",
  databaseURL: "https://darwin-journal-prod.firebaseio.com",
  projectId: "darwin-journal-prod",
  storageBucket: "darwin-journal-prod.appspot.com",
  messagingSenderId: "984280624094"
};
firebase.initializeApp(config);

firebase.auth().onAuthStateChanged((user) => {
  if (user === null) {
    signIn();
  }

  var data = {
    displayName: user.displayName,
    photoUrl: user.photoURL,
    modifiedAt: firebase.firestore.FieldValue.serverTimestamp(),
    email: user.email,
    providerData: user.providerData,
    providerId: user.providerId,
  };

  firebase.firestore().collection('users').doc(user.uid).set(data, {merge: true});
});

firebase.firestore().enablePersistence()
  .then(function() {
      // Initialize Cloud Firestore through firebase
      var db = firebase.firestore();
  })
  .catch(function(err) {
      if (err.code == 'failed-precondition') {
          // Multiple tabs open, persistence can only be enabled
          // in one tab at a a time.
          // ...
      } else if (err.code == 'unimplemented') {
          // The current browser does not support all of the
          // features required to enable persistence
          // ...
      }

      console.log(err);
  });

function signIn() {
  var provider = new firebase.auth.GoogleAuthProvider();
  provider.addScope('https://www.googleapis.com/auth/contacts.readonly');
  firebase.auth().signInWithRedirect(provider).then(function(result) {
    // This gives you a Google Access Token. You can use it to access the Google API.
    var token = result.credential.accessToken;
    // The signed-in user info.
    var user = result.user;
    console.log(result);
  }).catch(function(error) {
    // Handle Errors here.
    var errorCode = error.code;
    var errorMessage = error.message;
    // The email of the user's account used.
    var email = error.email;
    // The firebase.auth.AuthCredential type that was used.
    var credential = error.credential;
    // ...
    console.log(error);
  });
}



ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js